(() => {
  'use strict';

  // Fallback gap in px when columnGap cannot be resolved from computed styles.
  const FALLBACK_GAP = 16;
  // Tolerance in px for detecting the scroll start/end edges (sub-pixel rounding).
  const EDGE_TOLERANCE = 2;

  const getGap = (track) => {
    const columnGap = getComputedStyle(track).columnGap;
    const parsed = parseFloat(columnGap);
    return Number.isNaN(parsed) ? FALLBACK_GAP : parsed;
  };

  const getStep = (track) => {
    const firstItem = track.querySelector('.style-gallery__item');
    if (!firstItem) return 0;
    return firstItem.offsetWidth + getGap(track);
  };

  const updateButtons = (track, prev, next) => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= EDGE_TOLERANCE;
    next.disabled = track.scrollLeft >= maxScroll - EDGE_TOLERANCE;
  };

  const initGallery = (gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');

    if (!track || !prev || !next) return;

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(track), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(track), behavior: 'smooth' });
    });

    track.addEventListener(
      'scroll',
      () => {
        updateButtons(track, prev, next);
      },
      { passive: true }
    );

    updateButtons(track, prev, next);
  };

  const init = () => {
    const galleries = document.querySelectorAll('[data-style-gallery]');
    galleries.forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when the section is loaded/reordered in the theme editor.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-style-gallery]').forEach(initGallery);
  });
})();
